import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { site } from "../config/site";

const SECTIONS = [
  {
    title: "1. Dados que coletamos",
    body: "Coletamos apenas os dados que você envia voluntariamente pelo formulário de contato (nome, empresa, WhatsApp ou e-mail, segmento, serviço de interesse, objetivo e mensagem), além de parâmetros de origem de campanha (UTM), quando presentes na URL de acesso.",
  },
  {
    title: "2. Finalidade do tratamento",
    body: "Os dados enviados são utilizados exclusivamente para responder à sua solicitação, elaborar propostas comerciais e manter o contato iniciado por você. Não vendemos nem compartilhamos seus dados com terceiros para fins de marketing.",
  },
  {
    title: "3. Cookies e tecnologias de rastreamento",
    body: "Este site pode utilizar Google Tag Manager, Google Analytics 4, Google Ads e Meta Pixel para mensurar navegação e conversões. Essas tecnologias só são carregadas após o seu consentimento, registrado no banner de cookies. Você pode alterar ou revogar sua escolha a qualquer momento em \"Preferências de cookies\", no rodapé do site.",
  },
  {
    title: "4. Seus direitos (LGPD — Lei nº 13.709/2018)",
    body: "Você pode solicitar, a qualquer momento, a confirmação, o acesso, a correção, a anonimização, a portabilidade ou a eliminação dos seus dados pessoais, bem como revogar o consentimento concedido.",
  },
  {
    title: "5. Contato do controlador",
    body: `Para exercer seus direitos ou esclarecer dúvidas sobre esta política, fale com a GOBAX pelo WhatsApp ${site.whatsappDisplay || "informado no site"}${site.email ? ` ou pelo e-mail ${site.email}` : ""}.`,
  },
];

export default function Privacidade() {
  return (
    <div className="min-h-screen bg-gb-black" data-testid="privacy-page">
      <div className="mx-auto max-w-3xl px-4 py-16 sm:px-6 lg:py-24">
        <Link to="/" data-testid="privacy-back-link" className="inline-flex items-center gap-2 text-sm text-gb-gray transition-colors hover:text-gb-white">
          <ArrowLeft className="h-4 w-4" aria-hidden="true" />
          Voltar para o início
        </Link>
        <div className="mt-10 flex items-center gap-4">
          <img src="/assets/logo.jpg" alt="Logotipo GOBAX" width={48} height={48} className="h-12 w-12 rounded-full ring-1 ring-white/20" />
          <span className="font-mono text-[10px] uppercase tracking-[0.28em] text-gb-gray">GOBAX — {site.tagline}</span>
        </div>
        <h1 className="mt-8 font-display text-3xl font-extrabold tracking-tight sm:text-4xl">
          Política de <span className="chrome-text">Privacidade</span>
        </h1>
        <p className="mt-4 text-sm text-gb-gray">Última atualização: {new Date().toLocaleDateString("pt-BR")}</p>
        <div className="mt-12 space-y-10">
          {SECTIONS.map((s) => (
            <section key={s.title}>
              <h2 className="font-display text-lg font-bold">{s.title}</h2>
              <p className="mt-3 text-sm leading-relaxed text-gb-gray">{s.body}</p>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
